import { createResourceModule } from '../../../lib/resource/module.js';
import { taxDetailSchema } from './schemas.js';

export const taxes = createResourceModule({
  resource: 'taxes',
  basePath: '/v1/taxes',
  detail: taxDetailSchema,
});

export const taxEndpoints = taxes.endpoints;
